import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { CourseFilterCheckboxGroup } from './CourseFilterCheckboxGroup'
import { FilterDrawerType, FilterType } from './types'
import { CourseFilterAccordion } from '../CourseFilterAccordion/CourseFilterAccordion'

type Category = {
  id: string
  name: string
  attributes: Array<{ id: string; name: string }>
}

type Props = {
  type: FilterDrawerType
  onChange: (filterType: FilterType, value: string) => void
  category?: Category
}

export const CourseFilterCategory = ({ type, onChange, category }: Props) => {
  const filters = useAppSelector((state) => createFiltersSelector(state, type))

  if (!category || !category.attributes?.length) {
    return null
  }

  return (
    <CourseFilterAccordion
      key={category.id}
      title={category.name}
      badgeCount={filters.category?.[category.id]?.length || 0}
      testId="course-filter-category"
    >
      <CourseFilterCheckboxGroup<string>
        filterType={`category[${category.id}]` as FilterType}
        options={category.attributes?.map((attribute) => ({ label: attribute.name, value: attribute.id })) || []}
        filters={filters}
        onChange={onChange}
      />
    </CourseFilterAccordion>
  )
}
